import { PopUpComponent } from '../../../components/PopUpComponent';
import { ICatalogProvider } from '../../../interfaces/service/CatalogServiceManagerInterface';

interface IDisplayMappingSamProps {
  serviceCatalog: ICatalogProvider;
}

export const DisplayMappingJsonDataModal = (props: IDisplayMappingSamProps) => {
  const { serviceCatalog } = props;

  let mapping: any;
  let mappingInJson: any[] = [];
  let errorInJson: string = '';
  let title: string = 'Mapeo';

  if (serviceCatalog?.dataRow?.Mapping) {
    mapping = serviceCatalog?.dataRow?.Mapping[0]?.samMapping;
    mappingInJson = JSON.parse(mapping);
    title = 'Mapeo de SAM';
  }

  else if (serviceCatalog?.dataRow?.isActive) {
    mapping = serviceCatalog?.dataRow?.cardMapping;
  
    try {
      const parsed = JSON.parse(mapping);
      mappingInJson.push(parsed);
      title = 'Mapeo de tarjetas';
    } catch (error) {
      errorInJson = mapping;
    }
  }

  const bodyModalContent = () => {
    if (errorInJson !== '') {
      return (
        <div>
          <span>
            El mapeo no contiene información válida para generar el JSON correspondiente.
            <br />
            Información actual: {errorInJson}
          </span>
        </div>
      );
    }
  
    if (!mapping || mappingInJson.length === 0) {
      return <div>No hay datos disponibles.</div>;
    }
  
    return (
      <div className="flex w-full h-full gap-3 p-4">
        {mappingInJson.map((item: any, index: number) => (
          <div className="flex" key={index}>
            <pre className="select-none">{JSON.stringify(item, null, 2)}</pre>
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      {serviceCatalog?.dataRow?.Mapping || serviceCatalog?.dataRow?.cardMapping ? (
        <PopUpComponent
          header={title}
          showPopUp={serviceCatalog.showDisplayMappingModal}
          onSubmit={() => serviceCatalog.deleteCatalogItem()}
          onClosePopUp={() => serviceCatalog.closeMappingDetailModal()}
          body={bodyModalContent()}
        />
      ) : (
        <></>
      )}
    </>
  );
};
